(() => {
  const dialog = document.querySelector('.lps-viewer');
  if (!dialog || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  const image = dialog.querySelector('img');
  const caption = dialog.querySelector('.lps-viewer-caption');
  const zoom = dialog.querySelector('[data-story-zoom]');
  const stage = dialog.querySelector('.lps-viewer-stage');
  let opener;
  let oldOverflow;
  function setZoom(on) {
    dialog.classList.toggle('is-zoomed', on);
    zoom.setAttribute('aria-pressed', String(on));
    zoom.textContent = on ? 'Fit image' : 'Zoom +';
    stage.scrollTop = 0;
    stage.scrollLeft = 0;
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-story-image]');
    if (!button) return;
    opener = button;
    image.src = button.dataset.storyImage;
    image.alt = button.dataset.storyCaption || '';
    caption.textContent = image.alt;
    setZoom(false);
    oldOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    dialog.showModal();
  });
  dialog.querySelector('[data-story-close]').addEventListener('click', () => dialog.close());
  zoom.addEventListener('click', () => setZoom(!dialog.classList.contains('is-zoomed')));
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('keydown', event => {
    if (event.key === '+' || event.key === '=') { event.preventDefault(); setZoom(true); }
    if (event.key === '-' || event.key === '0') { event.preventDefault(); setZoom(false); }
  });
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = oldOverflow || '';
    opener?.focus({ preventScroll: true });
  });
})();
(() => {
  const dialog = document.querySelector('.lps-feature-dialog');
  if (!dialog || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  const content = dialog.querySelector('.lps-feature-content');
  let opener;
  let oldOverflow;
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-story-feature]');
    if (!button) return;
    const template = document.getElementById(button.dataset.storyFeature);
    if (!template) return;
    opener = button;
    content.replaceChildren(template.content.cloneNode(true));
    content.scrollTop = 0;
    oldOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    dialog.showModal();
  });
  dialog.querySelector('[data-feature-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = oldOverflow || '';
    opener?.focus({preventScroll:true});
  });
})();
